import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usuarios-roadshow',
  templateUrl: './usuarios-roadshow.component.html',
  styleUrls: ['./usuarios-roadshow.component.scss']
})
export class UsuariosRoadshowComponent implements OnInit {

  public loading: boolean = false;
  public isDisabledUser: boolean = false;

  public alertFail: boolean = false;
  public alertSuccess: boolean = false;
  public alertAccess: boolean = false;
  
  public alertMsg: string = '';
  public vertabla: boolean = false;
  public verForm: boolean = false;

  public editar: boolean = false;
  public cancelar: boolean = false;
  public guardar: boolean = true;

  usuario = {
    ci: '',
    nombre: '',
    apellido: '',
    password: '',
    email: ''
  }

  constructor() { }

  ngOnInit(): void {
  }

  doGuardar(){
    
  }

  doEditar(){
    
  }

  doCancelar(){

  }
  
  toggleTable(event){

  }
  
  closeForm(){

  }
}
